import React from "react";

const MAP = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-slate-100 text-slate-500 border-slate-200",
  suspended: "bg-red-50 text-red-700 border-red-200",
  provisioning: "bg-amber-50 text-amber-700 border-amber-200",
  INFO: "bg-blue-50 text-blue-700 border-blue-200",
  WARNING: "bg-amber-50 text-amber-700 border-amber-200",
  CRITICAL: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status, label, testId }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-xs font-medium capitalize ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label || status}
    </span>
  );
}
